import { getFilterTemplates } from '../Filter.api'

export function getTemplates(search, apiParams) {
  const params = {
    ...(search ? { search } : null),
  }

  return getFilterTemplates({
    ...apiParams,
    ...params,
  })
}
